import React, { FC, useEffect } from 'react';
import { Button, Placeholder } from '$uikit';
import { useTranslator } from '$hooks';
import { showModal } from '$navigation/helper';
import { CurrencyEnum } from '$store/models';
import { OTHER } from '$shared/constants/pages';
import { Link } from 'react-router5';

export const OnlypaySuccess: FC = () => {
  const t = useTranslator();

  useEffect(() => {
    try {
      window.parent.postMessage('close_me', '*');
    } catch (e) {}
    try {
      window.opener?.postMessage({ type: 'payment_result', status: 'success' }, '*');
      window.close();
    } catch (e) {}
  }, []);

  return (
    <Placeholder
      centered
      title={t('top_up_success_title')}
      actions={
        <Link
          routeName={OTHER}
          routeParams={{ w: 'balance', currency: CurrencyEnum.EUR }}
          onClick={() => {
            try {
              window.parent.postMessage('close_me', '*');
            } catch (e) {}
          }}
        >
          <Button size="small">{t('top_up_success_btn')}</Button>
        </Link>
      }
    >
      {t('top_up_success_text')}
    </Placeholder>
  );
};
